// Duplicate the test sample below whenever you need
export const SampleTest = {
  TEST_ID: 'optimize-test-id',
  name: 'My test',
  variants: [
    {
      name: '0',
      weight: 1,
    },
    {
      name: '1',
      weight: 1,
    },
  ],
};

export const AttentiveAbcTest = {
  TEST_ID: 'QhoRuZ8iRJSUWfPC3wEW0g',
  name: 'SMS Capture on HP - January 2022',
};

export const CartModalTest = {
  TEST_ID: 'CknGehTYR8O0-INBudj4yw',
  name: 'Cart Modal Open test',
};

export const ProductFrequencyTest = {
  TEST_ID: 'yFmpHJSwQK2VQTqR_7mYOg',
  name: 'Recommended Product Frequency Test',
};

export const MembershipNavigationItemAbTest = {
  TEST_ID: 'KdXdqyQLSQ-uYcLNoxzEQA',
  name: 'Membership Navigation Item AB test',
};

export const SupplementsHomePageAbTest = {
  TEST_ID: 'ewIF5cQTQnyhljvMEsIf1g',
  name: 'HP Hero Supp Headline Variations - ABC Test - May 2021',
};

export const CustomNameProductCartAbcTest = {
  TEST_ID: 'CMUYck5NSq294BsHoffiXw',
  name: "User's name in product titles at Cart AB test - August 2021",
};

export const ReadMoreCollapsedProductCartAbTest = {
  TEST_ID: 'gsmREMkBTRC9XPqgTvIeGw',
  name: 'Read more section collapsed vs extended at Cart - AB test - September 2021',
};

export const IntroAssetSwapAbTest = {
  TEST_ID: '7Nq4XMC-RG605fBY6Oevng',
  name: 'Intro asset swap - sept 2021',
};

export const ExpressCheckoutAbTest = {
  TEST_ID: 'LixCqDh-QF-7qH7FKmJYDQ',
  name: 'Express Checkout AB Test - November 2021',
};

export const PrescriptionPageAbTest = {
  TEST_ID: '6s30d459QpuYcagvRsZbOg',
  name: 'Prescription-100p roll out AB test - March 2022',
};

export const FakeGoExperimentAbTest = {
  TEST_ID: 'b1lpZmZXS5-ZBibtL57hlw',
  name: 'Fake GO Experiment - January 2022',
};

export const FakeGoExperimentBisAbTest = {
  TEST_ID: 'FyTP3_e0RSSADpt-ieyQIQ',
  name: 'Fake GO Experiment Bis - January 2022',
};

export const GoFakeExperimentFliptIdAbTest = {
  TEST_ID: 'Up6y7M3BRkWzQ_DDtliuCQ',
  name: 'GO Fake Experiment Flipt ID - January 2022',
};

export const CartRedesignUIExperiment = {
  TEST_ID: 'WZNT1iQ7SBG0T1JJgs_2mw',
  name: 'Cart UI Updates - April 2022',
};

export const EmailCaptureConsultationExitPopup = {
  TEST_ID: '5-Wmnw9JRW2_06wnU2ufyw',
  name: 'Email capture in Consultation exit popup AB test - Feb 2022',
};

export const CanadianShippingFeesExperiment = {
  TEST_ID: '-hNOukyIT16kgDQgpGb4ug',
  name: 'Canadian Shipping Fees AB Test - April 2022',
};

export const KustomerLivechatAtCartAbTest = {
  TEST_ID: 'UUYYPSQHQCa7JwzdK5fBsw',
  name: 'Live Chat in Cart Account test - APRIL 2022',
};

export const PrescriptionScoringExperiment = {
  TEST_ID: 'CicCQoiXRHulg4kw4lUaIQ',
  name: 'Scoring Screen AB Test - May 2022',
};

export const InterstitialScreenExperiment = {
  TEST_ID: 'cZKhqpE1R6qofGBc1sVD3Q',
  name: 'Cart Interstitial screen Membership - Mars 2022',
};
